export const STORE_ITEMS_QUERY_KEY = 'storeItems';
export const STORE_COUPONS_QUERY_KEY = 'storeCoupons';
export const STORE_SPECIAL_OFFER_QUERY_KEY = 'specialOffer';

export const STORE_DONATIONS_QUERY_KEY = 'donations';
export const STORE_VOLUNTEER_DONATIONS_QUERY_KEY = 'volunteerDonations';

export const STATUSES_QUERY_KEY = 'statuses';

export const ORGANIZATIONS_QUERY_KEY = 'organizations';

export const DASHBOARD_QUERY_KEY = 'dashboard';

export const PENDING_VOLUNTEERS_QUERY_KEY = 'pending-volunteers';

export const ADMIN_PLACEHOLDERS_QUERY_KEY = 'admin-placeholders';
